import { ScrollProvider } from './components/ScrollContext';
import Router from './routes/router';
import ChatWidget from './components/ChatWidget';

function App() {
  return (
    <>
      <ScrollProvider>
        <Router></Router>
        {/* <CookiesConsent /> */}
        <ChatWidget />
      </ScrollProvider>
    </>
  );
}

export default App;
